import React from 'react'

import { Content } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import { SectionContainer } from '../../layouts'
import {
  heroFullBannerContainer,
  heroFullContentStyling,
  heroFullHeadingStyling,
  heroFullSlideHeading,
  heroFullSlidPosition,
  kickerHeroFull,
} from './HeroFullBanner.module.css'

const HeroFullBanner = ({ slice }) => {
  const {
    fullslidecontent,
    fullslideimagedesktop,
    fullslideimagemobile,
    slidecontenthalf,
    slideheadinghalf,
  } = slice
  const isDesktop = useMediaQuery('(min-width: 768px)')

  let backGroundImage = fullslideimagedesktop

  if (!isDesktop && fullslideimagemobile) {
    backGroundImage = fullslideimagemobile
  }

  return (
    <SectionContainer
      backGround={backGroundImage}
      extraClassName={heroFullBannerContainer}
    >
      <div className={`${heroFullSlideHeading} ${heroFullSlidPosition}`}>
        <Content
          extraClassName={heroFullHeadingStyling}
          renderContent={slideheadinghalf}
        />
        <Content
          extraClassName={heroFullContentStyling}
          renderContent={slidecontenthalf}
        />
      </div>
      <Content
        extraClassName={kickerHeroFull}
        renderContent={fullslidecontent}
      />
    </SectionContainer>
  )
}

export default HeroFullBanner
